import {Component, EventEmitter, OnInit, Output, signal} from '@angular/core';
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {CustomMessageService, ResponseHttpError, ResponseHttpSuccess, UtilService} from "library";
import {HttpStatusCode} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {EnrollmentStatus, SalesWorkflowSteps, SalesWorkflow} from "projects/store/src/app/enums";
import {forkJoin} from "rxjs";

@Component({
  selector: 'app-sales-phone-register',
  templateUrl: './sales-phone-register.component.html'
})
export class SalesPhoneRegisterComponent {
  requestId: string;
  categoryCode!: string;
  request: any = {};
  enrollmentStatus!: string;
  viewEnrollment = true;
  step!: string;
  visibleModalIMEI!: boolean;
  title = '¡Estupendo! Tu teléfono ya se encuentra enrolado';
  subtitle = 'No es necesario que hagas nada más en este punto. Presiona el botón para continuar.';
  phoneEnrollmentData: any;
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();

  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private customMessageService: CustomMessageService,
              private utilService: UtilService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.categoryCode = this.route.snapshot.params['category_code'];
    this.request = this.requestService.request;
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.utilService.enablePageLoading();
    this.requestService.getEnrollmentStatus(this.requestId).subscribe({
      next: (resp)=>{
        if(resp.status === HttpStatusCode.Ok) {
          this.enrollmentStatus = resp.body.data.type;
          // this.enrollmentStatus = EnrollmentStatus.manual // TEST MGP
          if (this.enrollmentStatus === EnrollmentStatus.async){
            this.title = 'El enrolamiento del teléfono ha sido diferido';
            this.subtitle = 'No es necesario que hagas nada más en este punto. Presiona el botón para continuar.';
          }
          if (this.enrollmentStatus === EnrollmentStatus.manual) {
            this.step = 'general-instructions';
          }

        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (err: ResponseHttpError)=>{
        this.customMessageService.responseNoticeHandler(err);
      },
      complete: () => {
        this.utilService.disablePageLoading();
      }
    })

  }

  onGotoStep() {
    // TODO revisar una mejor manera de saltarse el paso de enrolar el telefono cuando este ya esta enrolado (automatico)
    this.gotoStepEvent.emit({ flowCode: SalesWorkflow['autogestion-cliente'], stepCode: SalesWorkflowSteps['additional-customer-information']});
  }

  onGotoStepByCode(stepCode: string) {
    this.gotoStepEvent.emit({ stepCode });
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  onStep(step: string) {
    this.step = step;
  }

  setPhoneEnrollmentData(data: any) {
    this.phoneEnrollmentData = data;
  }

  visibleEnterModalIMEI(visible: boolean){
    this.visibleModalIMEI = visible;
  }

  protected readonly EnrollmentStatus = EnrollmentStatus;
}
